import {TEXT} from '@drivesally/sally-fw/lib/inputTypes';

// Attribute
import attribute from '@drivesally/sally-fw/lib/attribute/attribute';

// Types
import capitalWord from '@drivesally/sally-fw/lib/type/types/capitalWord.type';

export default attribute({
  type: TEXT,
  attribute: 'city',
  display: capitalWord,
  input: capitalWord,
  api: capitalWord,
  label: {
    default: 'City',
    short: 'City',
  },
});
